import './Dashboard.css';
import { Plus , ArrowClockwise, PersonCircle, BoxArrowRight, Book, Envelope, Quote, FileText} from 'react-bootstrap-icons';
import axios from 'axios';
import DatasetList from './ListeDatasets.js';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Papa from 'papaparse';
import { DATASET, globalSetDataset, modeExecution, SITE_WEB  } from './Global.js';
import { Link } from 'react-router-dom';
import ModalComponent from './ModalMsg.js';
//import swal from 'sweetalert'; // pour 2e solution (message)
import ListTreasure from './ListTreasure.js';
// import emailjs from 'emailjs-com';
// import JSZip from 'jszip';


function Dashboard() {

    const hasRefreshed = useRef(false);

    const [showImportModal, setShowImportModal] = useState(false);
    const [showCleanModal, setShowCleanModal] = useState(false);    

    const [modalAfterZipIsOpen, setModalAfterZipIsOpen] = useState(false);
    const [fileSelected, setFileSelected] = useState(false);

    // États pour les datasets single
    const [singleSelectedDataset, setSingleSelectedDataset] = useState(null);
    const [singleDatasetCharacteristics, setSingleDatasetCharacteristics] = useState(null);
    const [singleDatasets, setSingleDatasets] = useState([]);

    // États pour les trésors et leurs datasets
    const [selectedTreasure, setSelectedTreasure] = useState(null);
    const [treasureDetails, setTreasureDetails] = useState(null);
    const [treasureSelectedDataset, setTreasureSelectedDataset] = useState(null);
    const [treasureDatasetCharacteristics, setTreasureDatasetCharacteristics] = useState(null);

    // États pour les formulaires 
    const [showUserMenu, setShowUserMenu] = useState(false);
    // const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);
    // const [message, setMessage] = useState('');
    const [deleteMessage, setDeleteMessage] = useState('');
    const [contactMessage, setContactMessage] = useState('');

    const [showHelpMenu, setShowHelpMenu] = useState(false);
    const helpMenuRef = useRef(null);

    const [uploadedFileName, setUploadedFileName] = useState(null);
    const fileInputRef = useRef(null);

    const [showCitationsModal, setShowCitationsModal] = useState(false);
    const [showComputingModal, setShowComputingModal] = useState(false);

    const [showUploadProgressModal, setShowUploadProgressModal] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const [showTermsModal, setShowTermsModal] = useState(false);

    const menuRef = useRef(null);

    const listTreasureRef = useRef(null);

    const navigate = useNavigate();







    //********************************************

    useEffect(() => {
        console.log("[Dashboard] (useEffect) [navigate] ------------------------------------> ");

        const loadData = async () => {
            const token = sessionStorage.getItem('token');
            if (!token) {
                navigate('/');
                return;
            }
    
            const hasRefreshed = sessionStorage.getItem('dashboardRefreshed');
            if (!hasRefreshed) {
                sessionStorage.setItem('dashboardRefreshed', 'true');
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            }
        };
    
        loadData();
        console.log("[Dashboard] (useEffect) [navigate] ------------------------------------< ");
    }, [navigate]);





    //********************************************
    //  Just for dump when "selectedTreasure" or "singleSelectedDataset" or "treasureSelectedDataset" change

    useEffect(() => {

        console.log("[Dashboard] (useEffect) ------------------------------------");
        console.log("[Dashboard] (useEffect) selectedTreasure = [", selectedTreasure, "]");
        console.log("[Dashboard] (useEffect) singleSelectedDataset = [", singleSelectedDataset, "]");
        console.log("[Dashboard] (useEffect) treasureSelectedDataset = [", treasureSelectedDataset, "]");

    }, [selectedTreasure, singleSelectedDataset, treasureSelectedDataset]);








    //********************************************
    //  ...

    useEffect(() => {

        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowUserMenu(false);
            }
            if (helpMenuRef.current && !helpMenuRef.current.contains(event.target)) {
                setShowHelpMenu(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);







    //********************************************
    // Montage de la page DASHBOARD : nettoyage BDD

    useEffect(() => {
        // Optionnel : vérifie si tu viens de Compare avec location.state
        setShowCleanModal(true);
       
        // const selectedDataset = DATASET; // ou récupère le dataset courant
        // if (!selectedDataset) {
        //     setShowCleanModal(false);
        //     return;
        // }

        const token = sessionStorage.getItem('token');


        //--------- Init before call route

        // let _bTreasure = false
        // let _treasure_name = ""
        // let _dataset_single_name = ""
        // let _dataset_of_the_treasure = ""

        // if (selectedTreasure !== null) {

        //     _bTreasure = true
        //     _treasure_name = selectedTreasure.name

        //     if (treasureSelectedDataset !== null) {
        //         _dataset_of_the_treasure = treasureSelectedDataset
        //     }
        //     else { 
        //         console.log(`[Dashboard] (/${_function}) !!!!!!!! ERROR ... no dataset for the treasure selected !`);
        //         _dataset_of_the_treasure = ""
        //     }
        // }
        // else
        // {
        //     _bTreasure = false
        //     _treasure_name = ""

        //     if (singleSelectedDataset !== null) {
        //         _dataset_single_name = singleSelectedDataset
        //     }
        //     else
        //         _dataset_single_name = ""
        // }


        //--------- call route 
        axios.post(`${SITE_WEB}/clean-dataset-db-user`, {
            // bTreasure: _bTreasure,
            // treasureName: _treasure_name,
            // datasetTreasure: _dataset_of_the_treasure,
            // datasetSingle: _dataset_single_name
        }, { headers: { Authorization: `Bearer ${token}` } })
            .then(() => setShowCleanModal(false))
            .catch(() => setShowCleanModal(false));


    }, []);




    
    const fetchDatasets = async () => {
        const token = sessionStorage.getItem('token');

        let url = '';
        url = SITE_WEB + '/datasets'
        console.log("[Dashboard] [fetchDatasets] url = ", url)

        try {
            const response = await axios.get(url, {
            headers: { 'Authorization': `Bearer ${token}` }
            });
            setSingleDatasets(response.data);
        } catch (error) {
            console.error('Erreur:', error);
        }
    };



    // Appeler fetchDatasets au montage du composant
    useEffect(() => {
        // console.log('[Dashboard] (useEffect) Appeler fetchDatasets au montage du composant...');
        fetchDatasets();
        // console.log('[Dashboard] (useEffect) Appeler fetchDatasets au montage du composant... OK');
    }, []);






    // Fonction pour gérer le clic sur le bouton Refresh
    const handleRefresh = () => {
        // console.log('[Dashboard] (handleRefresh) ...');
        fetchDatasets();
        // console.log('[Dashboard] (handleRefresh) ... OK');
        window.location.reload();
    };




  //=======================================================
  function parseMatrix(matrixString) {

    if (matrixString === '0') {
        return [[0, 0, 0], [0, 0, 0]];
    }

    try {
        const cleanedString = matrixString.replace(/\[\s*/g, '[').replace(/\s*\]/g, ']').replace(/\s+/g, ' ');
        const rows = cleanedString.split('] [').map(row => {
            const trimmedRow = row.replace(/^\[\s*|\s*\]$/g, '');
            const values = trimmedRow.match(/-?\d+(\.\d+)?/g).map(value => parseFloat(value));
            return values;
        });
        return rows;
    } catch (error) {
        console.error('Erreur de parsing de la matrice :', error);
        return [[0, 0, 0], [0, 0, 0]];
    }
  } // parseMatrix








  //=======================================================
    async function goToComparePage() {
        
        let _dump = true
        let _function = "goToComparePage";

        if(_dump){
            console.log(`[Dashboard] (/${_function}) ****** START ...`);
        }

        setShowImportModal(true); // Affiche la modale

        const token = sessionStorage.getItem('token');


        let _bTreasure = false
        let _treasure_name = ""
        let _dataset_single_name = ""
        let _dataset_of_the_treasure = ""

        if (selectedTreasure !== null) {

            _bTreasure = true
            _treasure_name = selectedTreasure.name

            if (treasureSelectedDataset !== null) {
                _dataset_of_the_treasure = treasureSelectedDataset
            }
            else { 
                console.log(`[Dashboard] (/${_function}) !!!!!!!! ERROR ... no dataset for the treasure selected !`);
                _dataset_of_the_treasure = ""
            }
        }
        else
        {
            _bTreasure = false
            _treasure_name = ""

            if (singleSelectedDataset !== null) {
                _dataset_single_name = singleSelectedDataset
            }
            else
                _dataset_single_name = ""
        }



        // 1. Nettoyage préalable de la base pour ce dataset
        await axios.post(`${SITE_WEB}/clean-dataset-db-user`, {
            bTreasure: _bTreasure,
            treasureName: _treasure_name,
            datasetTreasure: _dataset_of_the_treasure,
            datasetSingle: _dataset_single_name
        }, { headers: { Authorization: `Bearer ${token}` } });

        // Import des paires
        await axios.post(`${SITE_WEB}/import-csv-to-mongo`, {
            bTreasure: _bTreasure,
            treasureName: _treasure_name,
            datasetTreasure: _dataset_of_the_treasure,
            datasetSingle: _dataset_single_name,
            type: 'pairs'
        }, { headers: { Authorization: `Bearer ${token}` } });

        // Import des notations
        await axios.post(`${SITE_WEB}/import-csv-to-mongo`, {
            bTreasure: _bTreasure,
            treasureName: _treasure_name,
            datasetTreasure: _dataset_of_the_treasure,
            datasetSingle: _dataset_single_name,
            type: 'notations'
        }, { headers: { Authorization: `Bearer ${token}` } });

        // Navigation vers la page Compare
        console.log("[Dashboard] (goToComparePage) ****** ... STOP");  
        setShowImportModal(false); // Cache la modale


        navigate('/compare', { 
            state: { 
                isTreasureDataset: _bTreasure, 
                treasureName: _treasure_name, 
                datasetTreasure: _dataset_of_the_treasure,
                datasetSingle: _dataset_single_name,
                index: 0
            }
        });
    }












  //=======================================================
  const viewCluster = async (dataset, treasure) => {

    let _dump = true;

    // *********************** Token
    const token = sessionStorage.getItem('token');
    if(_dump){
        console.log("[Dashboard] (viewCluster) token = ", token);
    }
    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    // *********************** Dataset (check)
    if(_dump){
        console.log("[Dashboard] (viewCluster) ********** dataset : ", dataset);
    }


    // *********************** fetchAndProcessClusters
    const fetchAndProcessClusters = async () => {
        try {
            let clustersResponse;

            let route_tmp;
            route_tmp = SITE_WEB + '/get-clusters-data'
            console.log("[Dashboard] (fetchAndProcessClusters) route_tmp = ", route_tmp)

            console.log("dataset = ", dataset);
            console.log("singleSelectedDataset = ", singleSelectedDataset);
            console.log("treasure = ", treasure);
            console.log("selectedTreasure = ", selectedTreasure);
            console.log("selectedTreasure?.name = ", selectedTreasure?.name); // selectedTreasure?.name

                clustersResponse = await axios.get(route_tmp, {
                    params: {
                        dataset: dataset || singleSelectedDataset,
                        treasure: treasure || selectedTreasure?.name
                    },
                    headers: { 'Authorization': `Bearer ${token}` }
                });

            console.log("clustersResponse:", clustersResponse);
            console.log("clustersResponse.data:", clustersResponse.data);

            if(clustersResponse.data) {
                // Navigation avec les données
                navigate('/cluster', { 
                    state: { 
                        clusterData: clustersResponse.data,
                        dataset: dataset || singleSelectedDataset,
                        treasure: treasure || selectedTreasure?.name
                    } 
                });
            }

        } catch (error) {
            console.error('Erreur lors de la récupération des données de clustering:', error);
        }
    };

    // Appeler la fonction asynchrone
    fetchAndProcessClusters();
};


    //=======================================================


    const handleUploadClick = async () => {
        const token = sessionStorage.getItem('token');
        try {
            const response = await axios.get(`${SITE_WEB}/isdatasetcomputing`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.data.isComputing) {
                setShowComputingModal(true);
                return;
            }
            // Si aucun dataset en calcul, ouvrir la boîte de dialogue
            document.getElementById('fileUpload').click();
        } catch (err) {
            alert('Error checking dataset status. Please try again.');
        }
    };



    //=======================================================
    const handleUpload = async (event) => { 

        let _dump = false;


        if(_dump){
            console.log("[Dashboard] (handleUpload) ... ");
        }
                  
        // *********************** file (check)
        const file = event.target.files[0];

        if(_dump){
            console.log("[Dashboard] (handleUpload) file = ", file);
        }


        // check size
        // const MAX_SIZE_GIGABYTES = 5; // UPLOADSIZE
        // const max_size_bytes = MAX_SIZE_GIGABYTES * 1024 * 1024 * 1024; // 5 Go en octets
        const MAX_SIZE_MEGABYTES = 500; // UPLOADSIZE
        const max_size_bytes = MAX_SIZE_MEGABYTES * 1024 * 1024; // 500 Mo en octets
        if (file && file.size > max_size_bytes) {
            if (fileInputRef.current) fileInputRef.current.value = null; // <-- AVANT le return
            alert("Your ZIP file exceeds 500 MB. For larger analyses, please contact the administrators."); // UPLOADSIZE
            return;
        }


        // *********************** .zip (check)
        if (file && file.name.endsWith('.zip')) {

            // 1e solution (un peu trop sommaire)
            // alert(
            //     `Your file has been selected. It will now be uploaded. This may take some time if the file is large. ` +
            //     `We suggest you to leave the site and reconnect later if this is the case. ` +
            //     `Instead, you can refresh the page with the corresponding button... `
            // );

            // 2e solution (semble deprecated)
            // swal({
            //     title: 'File Selected',
            //     text: 'Ok with the file',
            //     icon: 'success',
            //     buttons: {
            //       ok: {
            //         text: 'OK',
            //         className: 'btn btn-primary'
            //       }
            //     }
            //   });



            // Check inside ZIP
            // const zip = new JSZip();
            // try {
            //     const zipContent = await zip.loadAsync(file);
            //     const files = Object.values(zipContent.files);

            //     // Check file number
            //     if (files.length > 1000) {
            //         alert("Your ZIP contains more than 1000 files. For larger analyses, please contact the administrators.");
            //         return;
            //     }

            //     // Vérification que tous les fichiers sont des images
            //     const allowedExtensions = ['.jpg', '.jpeg', '.png', '.bmp', '.tif', '.tiff', '.gif', '.webp'];
            //     const nonImageFiles = files.filter(f => !f.dir && !allowedExtensions.some(ext => f.name.toLowerCase().endsWith(ext)));
            //     if (nonImageFiles.length > 0) {
            //         alert("Your ZIP must contain only image files (jpg, jpeg, png, bmp, tif, tiff, gif, webp).");
            //         return;
            //     }
            // } catch (err) {
            //     alert("Error reading ZIP file. Please check your file and try again.");
            //     return;
            // }

            // 3e solution (fenetre modale)
            setUploadedFileName(file.name); // Sauvegarder le nom du fichier
            setFileSelected(true);

            // setModalAfterZipIsOpen(true); // ?

            setShowUploadProgressModal(true);
            setUploadProgress(0);


            // *********************** Token
            const token = sessionStorage.getItem('token');
            if(_dump){
                console.log("[Dashboard] (handleUpload) token = ", token);
            }
            if (token) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            }

            // *********************** Prepa formData
            const formData = new FormData();
            formData.append('file', file);
            
            try {
                // send ZIP to server
                let response;

                let route_tmp;
                route_tmp = SITE_WEB + '/upload-zip'
                console.log("[Dashboard] (handleUpload) route_tmp = ", route_tmp)

                    response = await axios.post(route_tmp, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${token}`
                        },
                        timeout: 30 * 60 * 1000, // 30 minutes au lieu du défaut
                        maxContentLength: Infinity,
                        maxBodyLength: Infinity,
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            setUploadProgress(percentCompleted);
                            console.log(`Upload Progress: ${percentCompleted}%`);
                        }

                    });

                if (response.status === 200) {
                    console.log('[Dashboard] (handleUpload) ZIP file success:', response.data);
                    // Fermer la modale de progression et ouvrir celle de confirmation
                    // setShowUploadProgressModal(false);
                    // setModalAfterZipIsOpen(true);
                    setUploadProgress(100); // S'assurer que c'est à 100%
                } else {
                    console.error('[Dashboard] Error upload ZIP file:', response.statusText);
                    setShowUploadProgressModal(false);
                }
            } catch (error) {
                setShowUploadProgressModal(false);
                // if (error.response && error.response.data && error.response.data.error === 'too_many_files') {
                if (error.response && error.response.data.error === 'too_many_files') {
                    if (fileInputRef.current) fileInputRef.current.value = null; // <-- AVANT le return
                    alert('Too many files in your ZIP (>500). For larger analyses, please contact the administrators.');
                    setUploadedFileName(null);
                    setFileSelected(false);
                    setModalAfterZipIsOpen(false); // ?
                    return;
                }                
            } // try/catch
        } else {
            console.error('[Dashboard] Please select a valid ZIP file.');
        }
        if (fileInputRef.current) fileInputRef.current.value = null; // <-- AVANT le return
    }; // fin handleUpload







    const closeModal = () => {
        setUploadedFileName(null);
        setFileSelected(false);
        setModalAfterZipIsOpen(false);        // Refresh après 3 secondes 
        setTimeout(() => {
            handleRefresh();
        }, 3000);
    };





    //=======================================================
    const downloadNotationsCsv = async () => {

        try {
            // *********************** Token
            const token = sessionStorage.getItem('token');
            if (token) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            }

            // *********************** Requete
            let response;

            let route_tmp;
            route_tmp = SITE_WEB + '/download-notations-csv'
            console.log("[Dashboard] (downloadNotationsCsv) route_tmp = ", route_tmp)

                response = await axios.get(route_tmp, {
                    params: { dataset: singleSelectedDataset },
                    responseType: 'blob',
                    headers: { 'Authorization': `Bearer ${token}` },
                    withCredentials: true
                });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `notations_${singleSelectedDataset}.csv`);
            document.body.appendChild(link);
            link.click();

        } catch (error) {
            console.error('Error downloading notations.csv:', error);
        }
    };




    
    //=======================================================
    const downloadTreasureNotationsCsv = async () => {

        try {
            // *********************** Token
            const token = sessionStorage.getItem('token');
            if (token) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            }

            // *********************** Requete
            let response;

            let route_tmp;
            route_tmp = SITE_WEB + '/download-treasure-notations-csv'
            console.log("[Dashboard] (downloadTreasureNotationsCsv) route_tmp = ", route_tmp)

                response = await axios.get(route_tmp, {
                    params: { 
                        dataset: treasureSelectedDataset,
                        treasure: selectedTreasure.name
                    },
                    responseType: 'blob',
                    headers: { 'Authorization': `Bearer ${token}` },
                    withCredentials: true
                });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `notations_${treasureSelectedDataset}.csv`);
            document.body.appendChild(link);
            link.click();

            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);

        } catch (error) {
            console.error('Error downloading notations.csv:', error);
        }
    };





    const handleTreasureDeselect = () => {
        setSelectedTreasure(null);
        setTreasureDetails(null);
        setTreasureSelectedDataset(null);
        setTreasureDatasetCharacteristics(null);
        if (listTreasureRef.current) {
            listTreasureRef.current.resetSelection();
        }
    };

    



    //=======================================================
    const handleTreasureSelect = async (treasureData) => {
        let _dump = true;
        let _function = "handleTreasureSelect";

        try {
            const { item, type } = treasureData;
            
            if(_dump) {
                console.log(`[Dashboard] (${_function}) Starting with:`, { item, type });
            }

            // Gestion de la désélection
            if (type === 'deselect') {
                handleTreasureDeselect();
                return;
            }

            // Gestion du repli du menu
            if (type === 'collapse') {
                // Cacher uniquement l'affichage sans réinitialiser la sélection
                setTreasureDetails(null);
                setSelectedTreasure(null);
                return;
            }
    
            // Gestion des trésors
            if (type === 'treasure') {
                setSingleSelectedDataset(null);
                setSingleDatasetCharacteristics(null);
                setTreasureSelectedDataset(null);
                setTreasureDatasetCharacteristics(null);
                setSelectedTreasure(item);
                
                const token = sessionStorage.getItem('token');
                let response;
                
                let route_tmp;
                route_tmp = SITE_WEB + '/treasure-characteristics'
                console.log(`[Dashboard] (${_function}) route_tmp = `, route_tmp)

                response = await axios.get(route_tmp, {
                    params: { treasure: item.name },
                    headers: { 'Authorization': `Bearer ${token}` }
                });                

                if(_dump) {
                    console.log(`[Dashboard] (${_function}) Treasure details:`, response.data);
                }
    
                setTreasureDetails(response.data);
            } 
            // Gestion des datasets du trésor
            else if (type === 'dataset') {
                setTreasureDetails(null);
                setSingleSelectedDataset(null);
                setSingleDatasetCharacteristics(null);
                await fetchTreasureDatasetCharacteristics(item.name, item.treasureParent);
                // globalSetDataset(item.name);
                setTreasureSelectedDataset(item.name);
            }
        } catch (error) {
            console.error(`[Dashboard] (${_function}) Error:`, error);
        }
    };




    //=======================================================
    const fetchTreasureDatasetCharacteristics = async (dataset, treasureName) => {
        let _dump = true;
        
        try {
            if(!dataset || !treasureName) {
                console.error('Missing dataset or treasure name');
                return;
            }
    
            if(_dump) {
                console.log("[Dashboard] (fetchTreasureDatasetCharacteristics) Starting with:", {
                    dataset,
                    treasureName
                });
            }
    
            const token = sessionStorage.getItem('token');
            if (!token) {
                console.error('No authentication token found');
                return;
            }
    
            let response;

            let route_tmp;
            route_tmp = SITE_WEB + '/treasure-dataset-characteristics'
            console.log("[Dashboard] (fetchTreasureDatasetCharacteristics) route_tmp = ", route_tmp)

                response = await axios.get(route_tmp, {
                    params: { 
                        dataset: dataset,
                        treasure: treasureName
                    },
                    headers: { 'Authorization': `Bearer ${token}` }
                });

    
            if(_dump) {
                console.log("[Dashboard] (fetchTreasureDatasetCharacteristics) Response:", response.data);
            }
    
            // Mise à jour des états
            setTreasureSelectedDataset(dataset);
            setTreasureDatasetCharacteristics(response.data);
            
            // Réinitialiser les états des datasets single pour éviter les conflits
            setSingleSelectedDataset(null);
            setSingleDatasetCharacteristics(null);
    
        } catch (error) {
            console.error('[Dashboard] (fetchTreasureDatasetCharacteristics) Error:', error);
            if (error.response) {
                console.error('Server response:', error.response.data);
            }
            // Réinitialiser les états en cas d'erreur
            setTreasureSelectedDataset(null);
            setTreasureDatasetCharacteristics(null);
        }
    };




    //=======================================================
    const handleThresholdChange = async (treasureName, newThreshold) => {
        try {
        const token = sessionStorage.getItem('token');
        let response;
    
        let route_tmp;
        route_tmp = SITE_WEB + '/update-treasure-threshold'
        console.log("[Dashboard] (handleThresholdChange) route_tmp = ", route_tmp)

            response = await axios.put(route_tmp, 
                {
                    treasureName,
                    newThreshold: parseFloat(newThreshold)
                },
                {
                    headers: { 'Authorization': `Bearer ${token}` }
                }
            );
    
        if (response.status === 200) {
            // Mettre à jour le state local avec la nouvelle valeur
            setTreasureDetails(prevDetails => ({
            ...prevDetails,
            threshold: parseFloat(newThreshold)
            }));
            console.log('Threshold updated successfully');
        }
        } catch (error) {
        console.error('Error updating threshold:', error);
        if (error.response?.status === 403) {
            console.error('Not authorized to modify threshold');
        }
        }
    };



    
    
    const username = sessionStorage.getItem('username') || 'User';




    
    const handleLogout = () => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('dashboardRefreshed');
        sessionStorage.clear();
        navigate('/');
    };


    // const handleDeleteRequest = async (e) => {
    //     e.preventDefault();
    //     try {
    //         const token = sessionStorage.getItem('token');
    //         let response = '';

    //         let route_tmp = '';
    //         route_tmp = SITE_WEB + '/request-deletion';

    //         console.log("[Dashboard] (handleDeleteRequest) route_tmp = ", route_tmp)

    //             response = await axios.post(route_tmp, 
    //                 { deleteMessage },
    //                 { headers: { 'Authorization': `Bearer ${token}` } }
    //             );            
    
    //         alert('Your deletion request has been sent successfully.');
    //         setShowDeleteModal(false);
    //         setMessage('');
    //     } catch (error) {
    //         alert('Error sending deletion request. Please try again.');
    //     }
    // }; // fin handleDeleteRequest

    



    // const handleContact = async (e) => {
    //     e.preventDefault();
    //     try {
    //         const token = sessionStorage.getItem('token');
    //         let response = '';
    
    //         let route_tmp = '';
    //         route_tmp = SITE_WEB + '/contact-admin';

    //         console.log("[Dashboard] (handleContact) route_tmp = ", route_tmp)

    //             response = await axios.post(route_tmp,
    //                 { contactMessage },
    //                 { headers: { 'Authorization': `Bearer ${token}` } }
    //             );
    
    //         alert('Your message has been sent successfully.');
    //         setShowContactModal(false);
    //         setMessage('');
    //     } catch (error) {
    //         alert('Error sending message. Please try again.');
    //     }
    // }; // fin handleContact




    const handleDownloadManual = async () => {
        try {
            // *********************** Token
            const token = sessionStorage.getItem('token');
            if (token) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            }

            // *********************** Requete
            let response;

            let route_tmp;
            route_tmp = SITE_WEB + '/download-manual'
            console.log("[Dashboard] (handleDownloadManual) route_tmp = ", route_tmp)

                response = await axios.get(route_tmp, {
                    responseType: 'blob',
                    headers: { 'Authorization': `Bearer ${token}` },
                });
    
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ACCADIL_manual.pdf');
            document.body.appendChild(link);
            link.click();

            //Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);

        } catch (error) {
            console.error('Error downloading manual:', error);
            alert('Error downloading the manual. Please try again later.');
        }
    };



    //=======================================================
    return (
 
        
        <div className="dashboard-container">

            {showCleanModal && (
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                <div className="custom-modal-header">
                    <h5 className="modal-title">Please wait, clear database...</h5>
                </div>
                <div className="custom-modal-body">
                    <p>Cleaning in progress, please wait...</p>
                </div>
                </div>
            </div>
            )}

            {showComputingModal && (
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                <div className="custom-modal-header">
                    <h5 className="modal-title">Upload not allowed</h5>
                </div>
                <div className="custom-modal-body">
                    <p>One of your datasets is still in computing, please retry later.</p>
                </div>
                <div className="custom-modal-footer" style={{ textAlign: 'center' }}>
                    <button className="btn btn-primary" onClick={() => setShowComputingModal(false)}>
                    OK
                    </button>
                </div>
                </div>
            </div>
            )}

            {showImportModal && (
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                <div className="custom-modal-header">
                    <h5 className="modal-title">Import in progress</h5>
                </div>
                <div className="custom-modal-body">
                    <p>Import coins in database, please wait...</p>
                </div>
                </div>
            </div>
            )}       
                            {/* <div className="header-container">
                        <h1 className="dashboard-title">Dashboard</h1>
                        <LogoutButton />
                    </div> */}
            <div className="banner">
                <div className="banner-left">
                    <h1>Dashboard</h1>
                </div>
                <div className="banner-right">
                    <div className="user-menu-container">

                        <button
                            className="help-btn"
                            onClick={() => setShowTermsModal(true)}
                        >
                            <FileText className="help-icon" />
                            <span>Terms & Conditions</span>
                        </button>

                        <button
                            className="help-btn"
                            onClick={() => setShowCitationsModal(true)}
                        >
                            <Quote className="help-icon" />
                            <span>Citations</span>
                        </button>         

                        <button className="help-btn" onClick={() => setShowHelpMenu(!showHelpMenu)}>
                            <Book className="help-icon" />
                            <span>User Guide</span>
                        </button>

                        {showHelpMenu && (
                            <div className="user-menu-dropdown" ref={helpMenuRef}>
                                <button onClick={() => {
                                    handleDownloadManual();
                                    setShowHelpMenu(false);
                                }}>
                                    Download PDF Version
                                </button>
                            </div>
                        )}
                    
                        <button className="contact-btn" onClick={() => setShowUserMenu(!showUserMenu)}>
                            <Envelope className="contact-icon" />
                            <span>Contact</span>
                        </button>
                        {showUserMenu && (
                            <div className="user-menu-dropdown" ref={menuRef}>
                                <button onClick={() => {
                                    setShowContactModal(true);
                                    setShowUserMenu(false);
                                }}>
                                    Email
                                </button>
                            </div>
                        )}
                        
                    </div>
                    <div className="username-display">
                            <PersonCircle className="user-icon" />
                            <span>{username}</span>
                    </div>
                    <button className="logout-btn" onClick={handleLogout}>
                        <BoxArrowRight />
                        <span>Disconnect</span>
                    </button>
                </div>
            </div>

            {/* {showDeleteModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Request Account Deletion</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
                                </div>
                                <form onSubmit={handleDeleteSubmit}>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label>If you want, you can explain why you want to delete your account:</label>
                                            <textarea 
                                                className="form-control" 
                                                rows="4"
                                                value={deleteMessage}
                                                onChange={(e) => setDeleteMessage(e.target.value)}
                                                required
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                                        <button type="submit" className="btn btn-danger">Submit Request</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>
            )} */}

            {/* {showContactModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Contact Administrator</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowContactModal(false)}></button>
                                </div>
                                <form onSubmit={handleContact}>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label>Your message :</label>
                                            <textarea 
                                                className="form-control" 
                                                rows="4"
                                                value={contactMessage}
                                                onChange={(e) => setContactMessage(e.target.value)}
                                                required
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowContactModal(false)}>Cancel</button>
                                        <button type="submit" className="btn btn-primary">Send Message</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>
            )} */}
            {showContactModal && (
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                <div className="custom-modal-header">
                    <h5 className="modal-title">Contact</h5>
                </div>
                <div className="custom-modal-body">
                    <p>For any question, contact, request, or treasure analysis (multi-types), please send an email to <strong>accadil.project@gmail.com</strong> , with a short description of your request.</p>
                </div>
                <div className="custom-modal-footer">
                    <button 
                    className="btn btn-primary" 
                    onClick={() => setShowContactModal(false)}
                    >
                    OK
                    </button>
                </div>
                </div>
            </div>
            )}

            {showCitationsModal && (
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                <div className="custom-modal-header">
                    <h5 className="modal-title">Citations</h5>
                </div>
                <div className="custom-modal-body" style={{ maxWidth: 600 , textAlign: 'left' }}>
                    <p>
                    If you use ACCADIL or any results produced by this interface or its algorithms in your own work, please cite both of the following references:<br /><br />
                    <em>
                        <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>Citation 1 : Interface</div>
                        <pre style={{ fontSize: '14px', background: '#f8f9fa', padding: '12px', borderRadius: '6px', whiteSpace: 'pre-wrap' }}>
                        @misc&#123;labedan2025interfacehommemachinepourlidentification,
                        title=&#123;Interface Homme-Machine pour l&apos;Identification des Liaisons de Coins&#125;,
                        author=&#123;Patrice Labedan and Nicolas Drougard&#125;,
                        year=&#123;2025&#125;,
                        eprint=&#123;2511.05136&#125;,
                        archivePrefix=&#123;arXiv&#125;,
                        primaryClass=&#123;cs.HC&#125;,
                        url=&#123;https://arxiv.org/abs/2511.05136&#125;
                        &#125;
                        </pre>
                        <br />
                        <div style={{ margin: '16px 0 8px 0', fontWeight: 'bold' }}>Citation 2 : Algorithms</div>
                        <pre style={{ fontSize: '14px', background: '#f8f9fa', padding: '12px', borderRadius: '6px', whiteSpace: 'pre-wrap' }}>
                        @article&#123;labedan2025high,
                        title=&#123;A High-Accuracy SSIM-based Scoring System for Coin Die Link Identification&#125;,
                        author=&#123;Labedan, Patrice and Drougard, Nicolas and Berezin, Alexandre and Sun, Guowei and Dieulafait, Francis&#125;,
                        journal=&#123;arXiv preprint arXiv:2502.01186&#125;,
                        year=&#123;2025&#125;
                        &#125;
                        </pre>
                    </em>
                    </p>
                </div>
                <div className="custom-modal-footer" style={{ textAlign: 'center' }}>
                    <button className="btn btn-primary" onClick={() => setShowCitationsModal(false)}>
                    OK
                    </button>
                </div>
                </div>
            </div>
            )}            


            {/* {showUploadProgressModal && (
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                <div className="custom-modal-header">
                    <h5 className="modal-title">Uploading...</h5>
                </div>
                <div className="custom-modal-body">
                    <p>Uploading your ZIP file, please wait...</p>
                    <div style={{ 
                    width: '100%', 
                    backgroundColor: '#e0e0e0', 
                    borderRadius: '10px', 
                    overflow: 'hidden',
                    marginTop: '20px'
                    }}>
                    <div style={{
                        width: `${uploadProgress}%`,
                        height: '20px',
                        backgroundColor: '#007bff',
                        transition: 'width 0.3s ease',
                        borderRadius: '10px'
                    }}></div>
                    </div>
                    <p style={{ textAlign: 'center', marginTop: '10px', fontSize: '18px', fontWeight: 'bold' }}>
                    {uploadProgress}%
                    </p>
                </div>
                </div>
            </div>
            )}                 */}

            {showUploadProgressModal && (
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                <div className="custom-modal-header">
                    <h5 className="modal-title">
                    {uploadProgress === 100 ? "Upload Complete" : "Uploading..."}
                    </h5>
                </div>
                <div className="custom-modal-body">
                    {uploadProgress === 100 ? (
                    <>
                        <p>Your ZIP file has been uploaded successfully!</p>
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <button 
                            className="btn btn-primary"
                            onClick={() => {
                            setShowUploadProgressModal(false);
                            setModalAfterZipIsOpen(true); // Ouvrir la modale de confirmation
                            }}
                        >
                            OK
                        </button>
                        </div>
                    </>
                    ) : (
                    <>
                        <p>Uploading your ZIP file, please wait...</p>
                        <div style={{ 
                        width: '100%', 
                        backgroundColor: '#e0e0e0', 
                        borderRadius: '10px', 
                        overflow: 'hidden',
                        marginTop: '20px'
                        }}>
                        <div style={{
                            width: `${uploadProgress}%`,
                            height: '20px',
                            backgroundColor: '#007bff',
                            transition: 'width 0.3s ease',
                            borderRadius: '10px'
                        }}></div>
                        </div>
                        <p style={{ textAlign: 'center', marginTop: '10px', fontSize: '18px', fontWeight: 'bold' }}>
                        {uploadProgress}%
                        </p>
                    </>
                    )}
                </div>
                </div>
            </div>
            )}

            {showTermsModal && (
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                <div className="custom-modal-header">
                    <h5 className="modal-title">Terms & Conditions</h5>
                </div>
                <div className="custom-modal-body" style={{ maxWidth: 700, textAlign: 'left', maxHeight: '500px', overflowY: 'auto' }}>
                    <div>
                    {/* <h6><strong>1. Acceptance of Terms</strong></h6>
                    <p>By accessing and using ACCADIL, you agree to be bound by these Terms & Conditions.</p>
                    
                    <h6><strong>2. Use of Service</strong></h6>
                    <p>ACCADIL is provided for research and educational purposes. You agree to use the service responsibly and in accordance with applicable laws.</p>
                    
                    <h6><strong>3. Data Upload</strong></h6>
                    <p>You are responsible for the content you upload. You must ensure you have the right to upload and analyze the images you submit.</p>
                    
                    <h6><strong>4. Privacy and Data</strong></h6>
                    <p>Your uploaded data is processed for analysis purposes. We implement reasonable security measures to protect your data.</p>
                    
                    <h6><strong>5. Intellectual Property</strong></h6>
                    <p>The ACCADIL interface and algorithms are protected by intellectual property rights. If you use results from ACCADIL in your work, please cite the appropriate references as indicated in the Citations section.</p>
                    
                    <h6><strong>6. Limitation of Liability</strong></h6>
                    <p>ACCADIL is provided "as is" without warranties. We are not liable for any damages arising from the use of the service.</p>
                    
                    <h6><strong>7. Account Termination</strong></h6>
                    <p>We reserve the right to terminate accounts that violate these terms or for maintenance purposes.</p>
                    
                    <h6><strong>8. Changes to Terms</strong></h6>
                    <p>These terms may be updated from time to time. Continued use of the service constitutes acceptance of any changes.</p>
                    
                    <h6><strong>9. Contact</strong></h6>
                    <p>For questions about these terms, please contact: <strong>accadil.project@gmail.com</strong></p> */}
                    <h4>ACCADIL: General Terms and Conditions of Use</h4>
        
                    <h5>1. Purpose</h5>
                    <p>The application provided allows users to upload coin images to automatically evaluate 
                    the probabilities of die links using computer vision algorithms and artificial intelligence.</p>

                    <h5>2. Registration</h5>
                    <p>Access to the application requires free registration. Users must provide:</p>
                    <ul>
                        <li>A name (or pseudonym),</li>
                        <li>A valid email address,</li>
                        <li>A message for the application administrators (who will process the registration),</li>
                        <li>And accept these general terms and conditions of use.</li>
                    </ul>

                    <h5>3. Use of Uploaded Images</h5>
                    <p>By uploading coin images through the application, the user:</p>
                    <ul>
                        <li>Guarantees that they own the rights to use the images or have the necessary 
                        authorization to share them,</li>
                        <li>Expressly authorizes the application development team to use these images for:
                        <ul>
                            <li>The operation of the application and automated calculation of die links,</li>
                            <li>Scientific publications or academic communications relating to computer vision 
                            algorithms or artificial intelligence applied to numismatics.</li>
                        </ul>
                        </li>
                    </ul>

                    <p>No commercial use will be made of the uploaded images.<br/>
                    The images will not be resold, used for advertising campaigns, or shared with third 
                    parties for profit.</p>

                    <h5>4. Privacy</h5>
                    <p>Personal data collected (name, email, message) is used solely for the operation of 
                    the application, to potentially respond to users or ensure moderation. No personal 
                    information will be transmitted to third parties without the user's explicit consent. 
                    Each user may request their account to be deleted at any time.</p>

                    <h5>5. Responsibilities</h5>
                    <p>The application is provided free of charge and as-is, without guarantee of absolute 
                    accuracy of results. Users acknowledge that they use the application at their own risk.</p>

                    <h5>6. Applicable Law</h5>
                    <p>As this application is developed and managed from France, any matters related to its 
                    use will be handled according to French law. In case of disagreement, an amicable 
                    solution will always be sought first.</p>
                    {/* </div>                     */}
                    </div>
                </div>
                <div className="custom-modal-footer" style={{ textAlign: 'center' }}>
                    <button className="btn btn-primary" onClick={() => setShowTermsModal(false)}>
                    OK
                    </button>
                </div>
                </div>
            </div>
            )}

                <div className="dashboard-content">
                    <div className="content-container">
                        <div className="dataset-list-container">
                            <div className="upload-container">
                                <input
                                    type="file"
                                    id="fileUpload"
                                    accept=".zip"
                                    style={{ display: 'none' }}
                                    onChange={handleUpload}
                                    ref={fileInputRef}
                                />
                                <ModalComponent isOpen={modalAfterZipIsOpen} onRequestClose={closeModal}>
                                    <div style={{ width: '100%', padding: '20px' }}>
                                        <h2 style={{ 
                                            fontSize: '28px', 
                                            marginBottom: '25px', 
                                            color: '#333',
                                            textAlign: 'center' 
                                        }}>Upload in Progress</h2>
                                        <div style={{ 
                                            margin: '30px 0', 
                                            lineHeight: '2',
                                            fontSize: '18px'
                                        }}>
                                            <p style={{ marginBottom: '20px' }}>Your ZIP file is being processed. This may take some time.</p>
                                            <p style={{ marginBottom: '20px' }}>You can disconnect, and connect later.</p>
                                            {/* <p style={{ marginBottom: '20px' }}>You will receive an email notification when the processing is complete.</p> */}
                                            {/* <p style={{ marginBottom: '20px' }}>
                                                Once you receive the email, please click the 
                                                <span style={{ 
                                                    color: '#8b0000', 
                                                    fontWeight: 'bold',
                                                    fontSize: '24px',
                                                    margin: '0 8px'
                                                }}>↻</span> 
                                                Refresh button.
                                            </p> */}
                                            <p style={{ marginBottom: '20px' }}>
                                                Your dataset will be 
                                                <span style={{ 
                                                    color: '#6c757d', 
                                                    fontWeight: 'bold',
                                                    fontSize: '24px',
                                                    margin: '0 8px'
                                                }}>▤</span> 
                                                (Computing) and will change to 
                                                <span style={{ 
                                                    color: '#198754', 
                                                    fontWeight: 'bold',
                                                    fontSize: '24px',
                                                    margin: '0 8px'
                                                }}>▤</span> 
                                                (Ready)
                                            </p>
                                            <p style={{ marginBottom: '20px' }}>If your dataset doesn't respect the required format, it will not be displayed (see User Guide).</p>
                                        </div>
                                        <button 
                                            onClick={closeModal}
                                            style={{
                                                backgroundColor: '#0d6efd',
                                                color: 'white',
                                                border: 'none',
                                                padding: '12px 24px',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                fontSize: '18px',
                                                marginTop: '25px',
                                                width: '100%',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Understood
                                        </button>
                                    </div>
                                </ModalComponent>                       
                                <button
                                    className="upload-button"
                                    onClick={handleUploadClick}
                                    // onClick={() => document.getElementById('fileUpload').click()}
                                >
                                    <Plus className="icon" />
                                </button>
                                <button
                                    className="refresh-button"
                                    onClick={handleRefresh}
                                >
                                    <ArrowClockwise className="icon" />
                                </button>                        
                            </div>
                            <h3 className="single-title">Single Type</h3>
                            {(!singleDatasets || singleDatasets.length === 0) ? (
                                <div className="no-data-message">
                                    No datasets available. Use the + button to upload a new dataset.
                                </div>
                            ) : (
                            <>
                            
                            <DatasetList 
                                setSingleSelectedDataset={setSingleSelectedDataset}
                                setSingleDatasetCharacteristics={setSingleDatasetCharacteristics}
                                onTreasureDeselect={handleTreasureDeselect}
                            />
                            
                            </>
                            )}
                            
                            <ListTreasure
                                ref={listTreasureRef} 
                                onTreasureSelect={handleTreasureSelect}
                                onDatasetSelect={fetchTreasureDatasetCharacteristics}
                            />

                        </div>
            
                        <div className="dataset-details-container">
                            {/* Section pour les datasets single */}
                            {!selectedTreasure && singleSelectedDataset && singleDatasetCharacteristics && (
                                <div className="dataset-details">
                                    <h2><strong>{singleSelectedDataset}</strong></h2>
                                    <div className="button-group">
                                        <button 
                                            className="btn btn-primary" 
                                            // onClick={downloadCsvAndCompare}
                                            onClick={goToComparePage}
                                            disabled={singleDatasetCharacteristics.message}
                                        >
                                            Compare
                                        </button>
                                        <button 
                                            className="btn btn-primary" 
                                            onClick={downloadNotationsCsv} 
                                            disabled={singleDatasetCharacteristics.message}
                                        >
                                            Download results
                                        </button>
                                        <button 
                                            className="btn btn-primary" 
                                            onClick={() => {
                                                viewCluster(singleSelectedDataset);
                                            }}
                                            disabled={singleDatasetCharacteristics.message}
                                        >
                                            Cluster View
                                        </button>
                                    </div>
                                    {singleDatasetCharacteristics.message ? (
                                        <p>{singleDatasetCharacteristics.message}</p>
                                    ) : (
                                        <>
                                            <p>Coins: <strong>{singleDatasetCharacteristics.numberOfCoins}</strong></p>
                                            <p>Potential links: <strong>{singleDatasetCharacteristics.numberOfPotentialLinks}</strong></p>
                                            <table className="results-table">
                                                <thead>
                                                    <tr>
                                                        <th>Category</th>
                                                        <th>Count</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr><td>Not evaluated</td><td>{singleDatasetCharacteristics.results['-1']}</td></tr>
                                                    <tr><td>Linked</td><td>{singleDatasetCharacteristics.results['1']}</td></tr>
                                                    <tr><td>Probably linked</td><td>{singleDatasetCharacteristics.results['0.75']}</td></tr>
                                                    <tr><td>Don't know</td><td>{singleDatasetCharacteristics.results['0.5']}</td></tr>
                                                    <tr><td>Probably not linked</td><td>{singleDatasetCharacteristics.results['0.25']}</td></tr>
                                                    <tr><td>Not linked</td><td>{singleDatasetCharacteristics.results['0']}</td></tr>
                                                </tbody>
                                            </table>
                                        </>
                                    )}
                                </div>
                            )}
    
                            {/* Section pour les trésors et leurs datasets */}
                            {selectedTreasure && (
                                <>
                                    {/* Affichage des détails du trésor */}
                                    {!treasureSelectedDataset && treasureDetails && (
                                        <div className="treasure-details">
                                            <h2><strong>{selectedTreasure.name}</strong></h2>
                                            <div className="treasure-info">
                                            <p>Accessible/Total Datasets: <strong>{treasureDetails.datasetsCount}</strong></p>
                                            <p>Total Potential Links: <strong>{treasureDetails.totalLinks}</strong></p>
                                            <p>Estimated Links (below threshold): <strong>{treasureDetails.matchingLinks}</strong></p>
                                                
                                                <div className="threshold-section">
                                                    <p>Current Threshold: <strong>{treasureDetails.threshold}</strong></p>
                                                    {treasureDetails.isAdmin && (
                                                        <div>
                                                            <label>Modify threshold:</label>
                                                            <input 
                                                                type="number" 
                                                                step="0.01"
                                                                min="0"
                                                                max="1"
                                                                value={treasureDetails.threshold}
                                                                onChange={(e) => handleThresholdChange(selectedTreasure.name, e.target.value)}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                
                                                <table className="results-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Category</th>
                                                            <th>Count</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr><td>Not evaluated</td><td>{treasureDetails.results?.['-1'] || 0}</td></tr>
                                                        <tr><td>Linked</td><td>{treasureDetails.results?.['1'] || 0}</td></tr>
                                                        <tr><td>Probably linked</td><td>{treasureDetails.results?.['0.75'] || 0}</td></tr>
                                                        <tr><td>Don't know</td><td>{treasureDetails.results?.['0.5'] || 0}</td></tr>
                                                        <tr><td>Probably not linked</td><td>{treasureDetails.results?.['0.25'] || 0}</td></tr>
                                                        <tr><td>Not linked</td><td>{treasureDetails.results?.['0'] || 0}</td></tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
    
                                    {/* Affichage des détails du dataset du trésor */}
                                    {selectedTreasure && treasureSelectedDataset && treasureDatasetCharacteristics && (
                                        <div className="dataset-details">
                                            <h2><strong>{treasureSelectedDataset}</strong></h2>
                                            <div className="button-group">
                                                <button 
                                                    className="btn btn-primary" 
                                                    // onClick={downloadTreasureCsvAndCompare}
                                                    onClick={goToComparePage}
                                                    disabled={treasureDatasetCharacteristics.message}
                                                >
                                                    Compare
                                                </button>
                                                <button 
                                                    className="btn btn-primary" 
                                                    onClick={downloadTreasureNotationsCsv} 
                                                    disabled={treasureDatasetCharacteristics.message}
                                                >
                                                    Download Results
                                                </button>
                                                <button 
                                                    className="btn btn-primary" 
                                                    onClick={() => {
                                                        viewCluster(treasureSelectedDataset, selectedTreasure.name);
                                                    }}
                                                    disabled={treasureDatasetCharacteristics.message}
                                                >
                                                    Cluster View
                                                </button>
                                            </div>
                                            {treasureDatasetCharacteristics.message ? (
                                                <p>{treasureDatasetCharacteristics.message}</p>
                                            ) : (
                                                <div className="dataset-info">
                                                    <p>Coins: <strong>{treasureDatasetCharacteristics.numberOfCoins}</strong></p>
                                                    <p>Potential links: <strong>{treasureDatasetCharacteristics.numberOfPotentialLinks}</strong></p>
                                                    <table className="results-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Category</th>
                                                                <th>Count</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr><td>Not evaluated</td><td>{treasureDatasetCharacteristics.results['-1']}</td></tr>
                                                            <tr><td>Linked</td><td>{treasureDatasetCharacteristics.results['1']}</td></tr>
                                                            <tr><td>Probably linked</td><td>{treasureDatasetCharacteristics.results['0.75']}</td></tr>
                                                            <tr><td>Don't know</td><td>{treasureDatasetCharacteristics.results['0.5']}</td></tr>
                                                            <tr><td>Probably not linked</td><td>{treasureDatasetCharacteristics.results['0.25']}</td></tr>
                                                            <tr><td>Not linked</td><td>{treasureDatasetCharacteristics.results['0']}</td></tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
        </div>
    );    
}

export default Dashboard;